module.exports = __webpack_public_path__ + "img/exmple-5.b2db792a.png";